<div *ngIf="imageVisible" style="border: 1px dotted #ddd;
border-radius: 0px;padding: 15px 10px;" fxLayout="row" fxLayoutAlign.xs="center center" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxLayout="column">

        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px">

            <span fxLayoutAlign="start center">
                {{value}}
                <button [attr.guide]="'upload-pdf-btn-1' + '__' + sanitizeUrl(url)" *ngIf="value!=''"  (click)="download()" color="warn" mat-icon-button type="button">
                    <mat-icon>download

                    </mat-icon>

                </button>

            </span>

            <ng-container fxLayoutAlign.xs="center center" fxLayoutAlign="end center">
                <button [attr.guide]="'upload-pdf-btn-2' + '__' + sanitizeUrl(url)" (click)="logo()" mat-raised-button>Upload</button>

                <button [attr.guide]="'upload-pdf-btn-3' + '__' + sanitizeUrl(url)" *ngIf="value!=''" (click)="deleteImage(0)" mat-raised-button>delete</button>
            </ng-container>

        </div>
    </div>
</div>

<div *ngIf="!imageVisible&&!imageDelete" style="border: 1px dotted #ddd;border-radius: 0px;padding: 15px 10px;"
    fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <calsoft-common-file-upload-pdf (fileUploadResult)=getResult($event) [type]="'formPdf'">
    </calsoft-common-file-upload-pdf>
    <button [attr.guide]="'upload-pdf-btn-4' + '__' + sanitizeUrl(url)" (click)="cancelUpload()" mat-raised-button>Cancel</button>
</div>